import styled from "styled-components";

import { Modal } from "@similarweb/ui-components";

export const Container = styled(Modal.Content)`
    gap: 16px;
`;
